import { serverRouteConfig } from "@server/server-route-config"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/api/oidc/userinfo")(
  serverRouteConfig({
    server: {
      handlers: {
        GET: async ({ request }) => {
          const { handleShortLinksOidcUserinfo } = await import(
            "@api/features/short-links-sso/shortLinksOidcHandlers"
          )
          return handleShortLinksOidcUserinfo(request)
        },
      },
    },
  })
)
